import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function toggleGCalVisibility({
  calendarId,
  hidden,
}: {
  calendarId: string;
  hidden: boolean;
}) {
  const res = await fetchOrchidAPI(
    "/api/scheduler_calendar_integrations/toggle_google_calendar_visibility",
    {
      method: "POST",
      body: JSON.stringify({
        calendar_id: calendarId,
        hidden,
      }),
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return;
}
